import {login, logout, getInfo, getClientById} from '@/api/login'
import {queryClientList} from '@/api/common'
import {
  getToken,
  setToken,
  setDetectToken,
  removeToken,
  setCompanyId,
  setCompanyName,
  setIcon,
  setDbIndex,
  setIsPrintOther,
  getIsPrintOther,
} from '@/utils/auth'
import webSocketManager from '@/utils/webSocketLink'
import { getCompanyId } from "@/utils/auth.js"
import { allSettled } from "@/utils/filter.js"
import Cookies from 'js-cookie'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    clientList: [],
    websocketConnected: false,
    // pdf报告状态，0: pdf；1: h5；undefined:接口请求失败;
    printVersion: undefined
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CLIENT_LIST: (state, list) => {
      state.clientList = list
    },
    SET_WEBSOCKET_STATUS: (state, status) => {
      state.websocketConnected = status
    },
    SET_PRINT_VERSION: (state, value) => {
      state.printVersion = value
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      const username = userInfo.username.trim();

      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {

          const data = response.body.data
          console.log('data',data)
          const tokenStr = data.tokenHead + data.token
          setDetectToken(data.detectToken)
          setCompanyId(data.companyId)
          setIcon(data.icon)
          setCompanyName(data.companyName)
          setDbIndex(data.dbIndex)
          setIsPrintOther(data.isPrintOther)
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          Cookies.set("correspondingApp", data.correspondingApp ? data.correspondingApp : "");
          resolve()
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        const p1 = getClientById(getCompanyId());
        const p2 = getInfo();
        allSettled([p1, p2]).then((arr) => {
          if(arr[0].status === "fulfilled") {
            commit("SET_PRINT_VERSION", arr[0].value.body.data.printVersion);
          }

          if(arr[1].status === "fulfilled") {
            try{
              const response = arr[1].value;
              const data = response.body.data
              if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                commit('SET_ROLES', data.roles[0])
              } else {
                reject('getInfo: roles must be a non-null array !')
              }
              commit('SET_NAME', data.username)
              commit('SET_AVATAR', data.icon)
              resolve(response)
            }catch(error) {
              reject(error)  
            }
          }else {
            reject(arr[1].reason)
          }
        })
        /*
        getInfo().then(response => {
          const data = response.body.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles[0])
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
        */
      })
    },

    GetClientList({commit}) {
      return new Promise((resolve, reject) => {
        queryClientList().then(res => {
          commit('SET_CLIENT_LIST', res.body.data)
          resolve()
        }).catch(() => {
          reject()
        })
      });
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          // 登出时关闭WebSocket连接
          webSocketManager.closeConnection()
          commit('SET_WEBSOCKET_STATUS', false)
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        // 前端登出时也要关闭WebSocket连接
        webSocketManager.closeConnection()
        commit('SET_WEBSOCKET_STATUS', false)
        
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js